<template>
    <div id="connectionContainer">
        <div v-show="!this.$store.state.loading && !this.$store.state.successful">
            <!-- TODO: コンポーネント化 ↓ -->
            <div class="connectionHeader">
                <div class="connectionInfo">
                    <!-- 広告クラスタ - 広告 紐付け設定 -->
                    <div v-if="'url' in this.itemAndAds.item">
                        <p class="connectionInfoLine">
                            <span class="connectionInfoItem">広告クラスタ名 : </span>
                            <input class="adClusterInputText" type="text" v-model="adClusterName" />
                        </p>
                        <p class="connectionInfoLine">
                            <span class="connectionInfoItem">URL : </span>
                            <input class="adClusterInputText" type="text" v-model="adClusterUrl" />
                        </p>
                    </div>
                    <!-- その他の紐付け設定 -->
                    <div v-else>
                        <p class="connectionInfoLine">
                            <span class="connectionInfoItem">商品名 : </span>
                            <span class="connectionInfoValue">{{ this.itemAndAds.item.name }}</span>
                        </p>
                        <p class="connectionInfoLine">
                            <span class="connectionInfoItem">商品ID : </span>
                            <span class="connectionInfoValue">{{ this.itemAndAds.item.id }}</span>
                        </p>
                    </div>
                </div>
                <a class="btn closeBtn" @click="$emit('modalClosed')">×</a>
            </div>
            <!-- TODO: コンポーネント化 ↑ -->

            <div class="connectionSetting">
                <div class="connectionSettingHeader">
                    <div class="connectionSettingHeaderItem">
                        <input id="isLinkedThisProduct" type="checkbox" v-model="isChecked">
                        <label class="isLinkedThisProductCheckBox"
                            for="isLinkedThisProduct">全広告クラスタの内いずれかと紐付き済み広告を非表示</label>
                    </div>
                </div>
                <div class="connectionListContainer">
                    <!-- 紐付け済み-->
                    <div class="connectionListInner">
                        <ul v-if="'linkedAds' in this.itemAndAds">
                            <li v-for="(linkedAd, adMedia, index) in this.itemAndAds.linkedAds" :key="index">
                                <div>
                                    <!-- 広告媒体名を表示 -->
                                    <div class="mediaLine">{{ adMedia }}</div>
                                    <!-- 広告媒体名ごとに広告セットを表示 -->
                                    <div v-for="(linkedAdset, adsetId, index) in linkedAd" :key="index"
                                        :class="{ 'isSelected': adMedia + '-' + adsetId === linkedActiveAdsetId }"
                                        class="adset" @click="onClick(adMedia, adsetId)">
                                        <!-- 広告セット名を表示 -->
                                        <span :class="{ 'adsetName': adMedia === 'google' }">
                                            {{
                                                linkedAdset['adset'][adsetId]['adGroupName']
                                            }}
                                        </span>
                                        <span v-if="adMedia === 'google'" class="right">
                                            {{
                                                linkedAdset['adset'][adsetId]['adCampaignName']
                                            }}
                                        </span>
                                        <!-- 広告を表示 -->
                                        <ul>
                                            <li v-for="(linkedAd, adId, index) in linkedAdset['ads']" :key="index">
                                                <span v-if="linkedAd['isLinkedThisItem']">○</span>
                                                <span v-else>× </span>
                                                <span>{{ linkedAd['adName'] }}</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="controlConnection">
                        <div class="connectionControlBtn">
                            <div>追加</div>
                            <div id="addBtn" class="controlBtn"
                                :class="{ 'isSelected': unlinkedActiveAdsetId !== null, 'notSelected': linkedActiveAdsetId !== null }"
                                @click="addAds(unlinkedActiveAdsetId)">←</div>
                        </div>
                        <div class="connectionControlBtn">
                            <div>削除</div>
                            <div id="deleteBtn" class="controlBtn"
                                :class="{ 'isSelected': linkedActiveAdsetId !== null, 'notSelected': unlinkedActiveAdsetId !== null }"
                                @click="deleteAds(linkedActiveAdsetId)">→</div>
                        </div>
                    </div>
                    <!-- 未紐付け-->
                    <div class="connectionListInner">
                        <ul v-if="'unlinkedAds' in this.itemAndAds">
                            <!-- 広告媒体ごとに広告を出力 広告媒体(Facebook, Yahoo(検索広告･ディスプレイ広告), Google, Line, Criteo) -->
                            <li v-for="(unlinkedAd, adMedia, index) in this.itemAndAds.unlinkedAds" :key="index">
                                <!-- 広告媒体名を表示 -->
                                <div class="mediaLine">{{ adMedia }}</div>
                                <!-- 広告媒体名ごとに広告セットを表示 -->
                                <div v-for="(unlinkedAdset, adsetId, index) in itemAndAds.unlinkedAds[adMedia]"
                                    :key="index">
                                    <div v-if="isExistLinkedAdsToAllAdClusters(unlinkedAdset)">
                                        <!-- 広告セット名を表示 -->
                                        <div :class="{ 'isSelected': adMedia + '-' + adsetId === unlinkedActiveAdsetId }"
                                            class="adset"
                                            @click="selectUnlinkedAdset(adMedia, adsetId, unlinkedAdset['ads'])">
                                            <span :class="{ 'adsetName': adMedia === 'google' }">
                                                {{
                                                    unlinkedAdset['adset'][adsetId]['adGroupName']
                                                }}
                                            </span>
                                            <span v-if="adMedia === 'google'" class="right">
                                                {{
                                                    unlinkedAdset['adset'][adsetId]['adCampaignName']
                                                }}
                                            </span>
                                        </div>
                                        <!-- 広告名を表示 -->
                                        <ul v-show="adMedia + '-' + adsetId == unlinkedActiveAdsetId"
                                            :class="{ 'isSelected': adMedia + '-' + adsetId === unlinkedActiveAdsetId }">
                                            <li v-for="(unlinkedAd, adId, index) in unlinkedAdset['ads']" :key="index">
                                                <div v-if="isChecked ? !unlinkedAd['isLinkedAllItems'] : true">
                                                    <input type="checkbox" :id="adId" v-model="checkBoxes[adId]"
                                                        @click="checkAd($event, adId)" />
                                                    <label :for="adId">{{ unlinkedAd['adName'] }}</label>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="connectionSettingFooter">
                    <a class="btn deleteBtn" @click="openDeleteModal">削除</a>
                    <a class="btn connectionSubmitBtn" @click="update">更新</a>
                    <div></div>
                </div>
                <modal name="deleteModal" :draggable="false" :resizable="false" width="60%" height="200px">
                    <DeleteModal @canceled="closeDeleteModal" @deleted="deleteAdCluster" />
                </modal>
            </div>
        </div>
    </div>
</template>

<script>
import DeleteModal from '../components/DeleteModal.vue';

export default {
    name: 'LinkAdClusterAndAds',
    data() {
        return {
            itemAndAds: { 'item': {} },
            linkedActiveAdsetId: null,
            unlinkedActiveAdsetId: null,
            activeAdIdsToAddToSubmmitData: {},
            activeAdsToAddToLinkedAds: {},
            submmitData: {},
            checkBoxes: {},
            isChecked: false,
            adClusterName: "",
            adClusterUrl: "",
        };
    },
    props: {
        adClusterId: Number
    },
    created: function () {
        this.$store.dispatch("loading", true);
        this.axios.get("/api/linkedAdClusters?adClusterId=" + this.adClusterId)
            .then((res) => {
                this.itemAndAds = res.data;
                // this.submmitData（送信データオブジェクト） を作成
                Object.keys(res.data.unlinkedAds).forEach((media) => {
                    this.$set(this.submmitData, media, []);
                });
                if ('linkedAds' in res.data) {
                    Object.keys(res.data.linkedAds).forEach((media) => {
                        Object.keys(res.data.linkedAds[media]).forEach((adsetId) => {
                            Object.keys(res.data.linkedAds[media][adsetId]['ads']).forEach((adId) => {
                                if (res.data.linkedAds[media][adsetId]['ads'][adId]['isLinkedThisItem']) {
                                    if (media in this.submmitData == false) {
                                        this.submmitData[media] = [];
                                    }
                                    this.submmitData[media].push(adId);
                                }
                            });
                        });
                    });
                }
                this.adClusterName = this.itemAndAds.item.name;
                this.adClusterUrl = this.itemAndAds.item.url;
                this.$store.dispatch("loading", false);
            }).catch(() => {
            });
    },
    methods: {
        isExistLinkedAdsToAllAdClusters(unlinkedAdset) {
            if (this.isChecked) {
                let isIncludLinkedAdsToAllAdClusters = false;
                Object.keys(unlinkedAdset['ads']).forEach((adId) => {
                    if (!unlinkedAdset.ads[adId].isLinkedAllItems) {
                        isIncludLinkedAdsToAllAdClusters = true;
                    }
                });
                return isIncludLinkedAdsToAllAdClusters;
            }
            else {
                return true;
            }
        },
        onClick(adMedia, adsetId) {
            // 設定済み広告セット押下時
            this.linkedActiveAdsetId = adMedia + '-' + adsetId;
            this.unlinkedActiveAdsetId = null;
            this.activeAdIdsToAddToSubmmitData = {};
            this.activeAdsToAddToLinkedAds = {};
            this.checkBoxes = {};
        },
        // 未紐付けの広告を紐付け済み広告へ追加
        addAds(unlinkedActiveAdsetId) {
            let spritedAdset = unlinkedActiveAdsetId.split('-');
            let selectedAdMedia = spritedAdset[0];
            let selectedAdsetId = spritedAdset[1];
            // submmitData に選択中の広告セットを追加
            this.activeAdIdsToAddToSubmmitData.true.forEach((adId) => {
                if (!this.submmitData[selectedAdMedia].includes(adId)) {
                    this.submmitData[selectedAdMedia].push(adId);
                }
            });
            this.activeAdIdsToAddToSubmmitData.false.forEach((adId) => {
                if (this.submmitData[selectedAdMedia].includes(adId)) {
                    let index = this.submmitData[selectedAdMedia].indexOf(adId);
                    this.submmitData[selectedAdMedia].splice(index, 1);
                }
            });
            // this.itemAndAds.linkedAds に広告を追加
            Object.keys(this.activeAdsToAddToLinkedAds).forEach((adId) => {
                if (!('linkedAds' in this.itemAndAds)) {
                    // 初期化
                    this.$set(this.itemAndAds, 'linkedAds', {});
                }
                if (!(selectedAdMedia in this.itemAndAds.linkedAds)) {
                    // 初期化
                    this.$set(this.itemAndAds.linkedAds, selectedAdMedia, {});
                }
                if (!(selectedAdsetId in this.itemAndAds.linkedAds[selectedAdMedia])) {
                    // 初期化
                    this.$set(this.itemAndAds.linkedAds[selectedAdMedia], selectedAdsetId, {});
                    this.$set(this.itemAndAds.linkedAds[selectedAdMedia][selectedAdsetId], 'ads', {});
                    this.$set(this.itemAndAds.linkedAds[selectedAdMedia][selectedAdsetId], 'adset', {});
                }
                this.$set(this.itemAndAds.linkedAds[selectedAdMedia][selectedAdsetId]['adset'], selectedAdsetId, {});
                this.$set(this.itemAndAds.linkedAds[selectedAdMedia][selectedAdsetId]['adset'][selectedAdsetId], 'adGroupName', this.itemAndAds.unlinkedAds[selectedAdMedia][selectedAdsetId]['adset'][selectedAdsetId]['adGroupName']);
                this.$set(this.itemAndAds.linkedAds[selectedAdMedia][selectedAdsetId]['adset'][selectedAdsetId], 'adCampaignName', this.itemAndAds.unlinkedAds[selectedAdMedia][selectedAdsetId]['adset'][selectedAdsetId]['adCampaignName']);
                this.$set(this.itemAndAds.linkedAds[selectedAdMedia][selectedAdsetId]['ads'], adId, {});
                this.$set(this.itemAndAds.linkedAds[selectedAdMedia][selectedAdsetId]['ads'][adId], 'adName', this.activeAdsToAddToLinkedAds[adId].adName);
                this.$set(this.itemAndAds.linkedAds[selectedAdMedia][selectedAdsetId]['ads'][adId], 'isLinkedThisItem', this.activeAdsToAddToLinkedAds[adId].isLinkedThisItem);
            });
            this.activeAdsToAddToLinkedAds = {};
            this.unlinkedActiveAdsetId = null;
            this.activeAdIdsToAddToSubmmitData = {};
            this.checkBoxes = {};
        },
        deleteAds(linkedActiveAdsetId) {
            let spritedAdset = linkedActiveAdsetId.split('-');
            let selectedAdMedia = spritedAdset[0];
            let selectedAdsetId = spritedAdset[1];
            // submmitData から削除
            Object.keys(this.itemAndAds.linkedAds[selectedAdMedia][selectedAdsetId]['ads']).forEach((adId) => {
                // submmitDataに追加済みの広告IDのみ削除
                if (this.itemAndAds.linkedAds[selectedAdMedia][selectedAdsetId]['ads'][adId].isLinkedThisItem) {
                    let index = this.submmitData[selectedAdMedia].indexOf(adId);
                    this.submmitData[selectedAdMedia].splice(index, 1);
                }
            });
            // linkedAds から削除
            this.$delete(this.itemAndAds.linkedAds[selectedAdMedia], selectedAdsetId);
            this.activeAdIdsToAddToSubmmitData = {};
            this.activeAdsToAddToLinkedAds = {};
        },
        // 未紐付け広告セットを選択
        selectUnlinkedAdset(adMedia, adsetId, ads) {
            let copiedads = JSON.parse(JSON.stringify(ads));
            // submmitData に追加する配列
            this.activeAdIdsToAddToSubmmitData = {};
            this.$set(this.activeAdIdsToAddToSubmmitData, 'true', []);
            this.$set(this.activeAdIdsToAddToSubmmitData, 'false', []);
            this.checkBoxes = {};
            Object.keys(copiedads).forEach((adId) => {
                let isLinkThisItem = false;
                if ('linkedAds' in this.itemAndAds
                    && adMedia in this.itemAndAds.linkedAds
                    && adsetId in this.itemAndAds.linkedAds[adMedia]
                    && this.itemAndAds.linkedAds[adMedia][adsetId].ads[adId].isLinkedThisItem) {
                    isLinkThisItem = true;
                }
                if (adMedia === 'googleShopping' || adMedia === 'googlePmax') {
                    copiedads = isLinkThisItem ? this.setDefault(copiedads, adId, true) : this.setDefault(copiedads, adId, false);
                }
                else {
                    if (this.isChecked) {
                        copiedads = copiedads[adId].isLinkedAllItems && !isLinkThisItem ? this.setDefault(copiedads, adId, false) : this.setDefault(copiedads, adId, true);
                    }
                    else {
                        copiedads = this.setDefault(copiedads, adId, true);
                    }
                }
            });
            this.activeAdsToAddToLinkedAds = JSON.parse(JSON.stringify(copiedads));
            this.unlinkedActiveAdsetId = adMedia + '-' + adsetId;
            this.linkedActiveAdsetId = null;
        },
        setDefault(copiedads, adId, boolean) {
            let ads = JSON.parse(JSON.stringify(copiedads));
            this.$set(this.checkBoxes, adId, boolean);
            this.activeAdIdsToAddToSubmmitData[String(boolean)].push(adId);
            ads[adId]['isLinkedThisItem'] = boolean;
            this.$delete(ads[adId], 'isLinkedAllItems');
            return ads;
        },
        checkAd(e, adId) {
            if (e.target.checked) {
                // チェックする
                this.$set(this.activeAdsToAddToLinkedAds[adId], 'isLinkedThisItem', true);
                this.activeAdIdsToAddToSubmmitData.true.push(adId);
                let indexFales = this.activeAdIdsToAddToSubmmitData.false.indexOf(adId);
                this.activeAdIdsToAddToSubmmitData.false.splice(indexFales, 1);
            }
            else {
                // チェック外す
                this.$set(this.activeAdsToAddToLinkedAds[adId], 'isLinkedThisItem', false);
                this.activeAdIdsToAddToSubmmitData.false.push(adId);
                let indexTrue = this.activeAdIdsToAddToSubmmitData.true.indexOf(adId);
                this.activeAdIdsToAddToSubmmitData.true.splice(indexTrue, 1);
            }
            e.stopPropagation();
        },
        update() {
            this.updateSettingAds();
            this.updateAdCluster();
        },
        updateSettingAds() {
            // 更新ボタン押下時
            this.axios.put("api/linkedAdClusters", {
                adClusterId: this.itemAndAds.item.id,
                adIds: this.submmitData
            }).then(() => {
            }).catch(() => {
            });
        },
        updateAdCluster() {
            var url = "/api/adClusters/" + this.adClusterId;
            var data = {
                "adClusterName": this.adClusterName,
                "adClusterUrl": this.adClusterUrl,
            };
            this.axios.put(url, data).then(() => {
                this.$emit('updated');
                this.modalShow = false;
                this.$modal.hide("LinkAdClusterAndAds");
            }).catch(() => {
            });
        },
        deleteAdCluster() {
            var url = "/api/adClusters/" + this.adClusterId;
            this.$store.dispatch("loading", true);
            this.axios.delete(url).then(() => {
                this.$emit('updated');
                this.modalShow = false;
                this.$modal.hide("LinkAdClusterAndAds");
            }).catch(() => {
            }).finally(() => {
                this.$store.dispatch("loading", false);
            });
        },
        openDeleteModal() {
            this.$modal.show('deleteModal');
        },
        closeDeleteModal() {
            this.$modal.hide('deleteModal');
        },
        modalClose() {
            this.$emit('modalClosed');
            this.$store.dispatch("successful", false);
        }
    },
    watch: {
        isChecked: function () {
            this.linkedActiveAdsetId = null; // 選択中紐付け済み広告セット（media-adsetId）。
            this.unlinkedActiveAdsetId = null; // 選択中未紐付け広告セット（media-adsetId）。
            this.activeAdIdsToAddToSubmmitData = {};
            this.activeAdsToAddToLinkedAds = {};
            this.checkBoxes = {};
        }
    },
    components: { DeleteModal }
}
</script>

<style scoped lang="sass">
#connectionContainer
    height: 100%
    margin: 15px 15px 0 20px
    overflow: scroll
    .cancelBtn
        width: 100px
        background-color: #ccc
        border: 1px solid #ccc
    .deleteBtn
        width: 100px
        background-color: #ff5252
        border: 1px solid #ff5252
    .connectionHeader
        display: flex
        font-size: 1.5rem
        height: 20%
        padding: 5px
        text-align: center
        .connectionInfo
            overflow-wrap: break-word
            width: 40%
            color: $grayColor
            flex: 1 1 100%
            .adClusterInputText
                width: 300px
                padding: 10px
                text-align: left
                &:focus
                    outline: 2px solid $mainColor
            .connectionInfoLine
                color: $grayColor
                font-size: 1.5rem
                margin-bottom: 25px
                text-align: left
                span
                    display: inline-block
                .connectionInfoItem
                    display: inline-block
                    min-width: 130px
                .connectionInfoValue
                    font-weight: 700
        .closeBtn
            border: 1px solid $whiteColor
            display: block
            flex: 1 0 auto
            font-size: 1.7rem
            height: 40px
            margin-left: 5px
            padding: 10px 10px
            width: 40px
            &:hover
                border: 1px solid $mainColor
    .connectionSetting
        color: $grayColor
        display: flex
        flex-direction: column
        font-size: 1.5rem
        height: 70%
        padding: 5px
        .connectionSettingHeader
            flex: 0 1 0%
            margin-bottom: 10px
            .connectionSettingHeaderItem
                float: right
                padding: 10px 0
                #isLinkedThisProduct
                    display: none
                .isLinkedThisProductCheckBox
                    line-height: 18px
                    padding-left: 25px
                    position: relative
                    &::before
                        background: $whiteColor
                        border: 1px solid $grayColor
                        content: ''
                        cursor: pointer
                        display: block
                        height: 15px
                        position: absolute
                        width: 15px
                    &::after
                        border-bottom: 3px solid $mainColor
                        border-right: 3px solid $mainColor
                        content: ''
                        cursor: pointer
                        display: block
                        height: 9px
                        left: 5px
                        margin-top: -8px
                        opacity: 0
                        position: absolute
                        top: 50%
                        transform: rotate(45deg)
                        width: 5px
                #isLinkedThisProduct:checked + .isLinkedThisProductCheckBox::after
                    opacity: 1
        .connectionListContainer
            display: flex
            flex: 1 1 0%
            .connectionListInner
                border: 1px solid $grayColor
                flex: 1 1 45%
                font-size: 1.3rem
                max-height: 560px
                overflow-Y: scroll
                .mediaLine
                    background: $mainColor
                    color: $whiteColor
                    padding: 5px
                .adset
                    cursor: pointer
                    list-style: none
                    margin: 4px 10px
                    transition: 0.2s ease-out
                    overflow: hidden
                    &:hover
                        background: $mainColor
                        color: $whiteColor
                    .adsetName
                        display: inline-block
                        white-space: nowrap
                        overflow: hidden
                        width: calc(100% - 250px)
                    .right
                        float: right
                        display: inline-block
                        width: 250px
                        white-space: nowrap
                    li
                        display: flex
                        flex-direction: row
                        margin: 5px 0
                        span
                            padding: 5px 2px
                .isSelected
                    background: $mainColor
                    color: $whiteColor
            .controlConnection
                align-self: center
                flex: 1 1 10%
                .connectionControlBtn
                    font-weight: 700
                    text-align: center
                    .controlBtn
                        background: #ccc
                        border: 1px solid $grayColor
                        border-radius: 4px
                        color: $whiteColor
                        height: 35px
                        line-height: 35px
                        pointer-events: none
                        transition: 0.2s ease-out
                        margin: 5px auto 30px
                        width: 35px
                        &:hover
                            background: $mainColor
                            color: $whiteColor
                    .isSelected
                        background: $whiteColor
                        color: $mainColor
                        cursor: pointer
                        pointer-events: auto
                    .notSelected
                        background: #ccc
                        color: $whiteColor
        .connectionSettingFooter
            display: flex
            flex: 0 1 0%
            justify-content: space-between
            margin-top: 50px
            .deleteBtn
                width: 100px
                padding: 15px 5px
                background-color: #ff5252
                border: 1px solid #ff5252
            .connectionSubmitBtn
                border: 1px solid $mainColor
                padding: 15px 5px
                width: 100px
                margin-left: -100px
                &:hover
                    border: 1px solid $mainColor
</style>